import './index.css';
import './i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { loadTagManager } from './analytics';
import { applyDomainFromUrl } from './api/fairDomain';
import { App } from './App';
import { readSavedCategories, setDefaultConsent } from './cookie-consent/consent-mode';

// Consent defaults first, then GTM: no tag may fire without a consent state.
// A returning visitor's saved choice is applied here directly; the consent
// manager itself starts later, once the fair's language is known.
setDefaultConsent(readSavedCategories());
loadTagManager();

// TESTING ONLY — remove with the rest of the domain override. Runs before the
// first render so the fair is settled by the time FairProvider fetches it.
if (applyDomainFromUrl()) {
  // The switch changed which fair this session targets. Reloading is the
  // simplest way to drop every cached fair-scoped response; this happens only
  // on an explicit switch, never on a normal visit.
  window.location.reload();
}

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
